<template>
  <div class="reports-add-jobs" style="margin-left: 10px">
    <el-button class="add" @click="openDialog" style="padding-left: 8px; padding-right: 8px">
      Фильтры
    </el-button>

    <el-dialog  append-to-body title="Фильтры" :visible.sync="dialogObject">
      <div>
        <filter-select
          style="margin-bottom: 5px"
          multiple
          v-model="form.employeeId"
          placeholder="Работник"
          label="ФИО"
          :options="[...users]"
        />
      </div>

      <filter-select
        style="margin-bottom: 5px"
        placeholder="Вид работы"
        v-model="form.workTypeId"
        label="Вид работы"
        multiple
        :options="[{label: 'Без вида работ', value: null},...workTypes]"
      />

      <el-form-item label="Табельный номер"   style="margin-bottom: 5px">
        <el-input placeholder="Табельный номер" v-model="form.personnelNumber"></el-input>
      </el-form-item>

      <el-form-item label="Код">
        <el-input placeholder="Код" v-model="form.code"></el-input>
      </el-form-item>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="apply(true)">Сбросить</el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="dialogObject = false">Отменить</el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="apply()"
          type="primary">Применить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";
import FilterSelect from "../../../../components/FilterSelect";
import TabelProxy from "../../../../proxy/TabelProxy";

export default {
  name: 'FilterUser',
  components: {FilterSelect},
  props: ['isWorkType', 'company', 'users', 'workTypes'],
  data() {
    return {
      dialogObject: false,
      saveFilter: {
        employeeId: null,
        workTypeId: "",
        code: "",
        personnelNumber: '',
      },
      form: {
        employeeId: null,
        workTypeId: "",
        code: "",
        personnelNumber: '',
      }
    };
  },
  methods: {
    apply(reset) {
      if(reset) {
        this.form = {
          employeeId: null,
          workTypeId: "",
          code: "",
          personnelNumber: '',
        }
      }
      this.saveFilter = {...this.form}
      this.$emit('apply-filters', this.form)
      setTimeout(() => {
        this.close()
      }, 10)
    },
    openDialog() {
      this.dialogObject = true;
    },
    close() {
      this.form = {...this.saveFilter}
      this.dialogObject = false;
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/company/FiltersUser.vue